import React from 'react';
import { useTranslation } from 'react-i18next';
import GridContainer from '../../../Grid/GridContainer';
import GridItem from '../../../Grid/GridItem';
import { DialogTraslado3Props } from './types';
import { useDialogTraslado } from './useDialogTraslado';
import ModalCalendarTransferView from './view/ModalCalendarTransferView';
import ModalCalendarTransferEdit from './edit/ModalCalendarTransferEdit';

const ModalCalendarTransfer: React.FC<DialogTraslado3Props> = (props) => {
  const { t } = useTranslation();
  const {
    state,
    isReady,
    formatTransferTypeRecive,
    formatDistance,
    translateStatus,
    formatPatientAddress,
    canAssignDriver,
    getStatus,
    handleToPDF,
    getTransferWayLabel,
    transferWay,
    isOneWay
  } = useDialogTraslado(props);

  if (!isReady) {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ textAlign: 'center', padding: '20px' }}>
            {String(t('common.loading'))}
          </div>
        </GridItem>
      </GridContainer>
    );
  }

  if (props.viewMode === 'edit' && !props.disabled) {
    return (
      <GridContainer>
        <ModalCalendarTransferEdit
          {...props}
          drivers={props.drivers}
          idTransfer={props.idTransfer}
          onScheduleUpdate={props.onScheduleUpdate}
          onCloseModal={props.onCloseModal}
        />
      </GridContainer>
    );
  }
  return (
    <GridContainer>
      <ModalCalendarTransferView
        event={props.event}
        appointment={props.appointment}
        customer={props.customer}
        state={state}
        formatTransferTypeRecive={formatTransferTypeRecive}
        formatDistance={formatDistance}
        translateStatus={translateStatus}
        formatPatientAddress={formatPatientAddress}
        canAssignDriver={canAssignDriver}
        getStatus={getStatus}
        handleToPDF={handleToPDF}
        t={t}
        getTransferWayLabel={getTransferWayLabel}
        transferWay={transferWay}
        isOneWay={isOneWay}
      />
    </GridContainer>
  );
};

export default ModalCalendarTransfer;